import React from 'react';
import { SimpleGallery } from "raffle-house-uikit";
import { simpleGalleryData } from '../../../lib/static-data';

export default function Gallery() {
  return (
    <SimpleGallery data={simpleGalleryData} />
  )
}
